import React from 'react';
import { observable, action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import TinyDatePicker from 'tiny-date-picker';
import { DateRangePicker } from 'tiny-date-picker/dist/date-range-picker';
import { classFormControl } from './_base';
import 'tiny-date-picker/tiny-date-picker.min.css';
import { formatValue, parseDateValue } from '../utils/format';
import { setCaretPosition } from '../utils/placeCursor';

import './msInputSimple.css';

export { Icon } from './icon';
const isDDMMFormat = () => root.app.settings?.date_format === 'DD/MM/YYYY';

const noop = () => {};
const inRangeDefault = () => true;

export const MSInputSimple = observer(class MSInputSimple extends React.Component {
  invalidValue = null;
  lastValidValue = null;
  focused = false;

  constructor(props) {
    super(props);

    makeObservable(this, { componentDidMount: false, componentDidUpdate: false, updateDPDate: false, render: false, 
      invalidValue: observable,
      lastValidValue: observable,
      focused: observable,
      onChange: action,
      onBlur: action,
      handleFocus: action
    });


    this.inputRef = React.createRef();
  }

  componentDidMount() {
    let { type, onChange, name, min, max, value, skipTime, inRange = inRangeDefault } = this.props;
    let inputRef = this.props.inputRef || this.inputRef;

    if (type === 'date' && inputRef.current) {
      this.dp = TinyDatePicker(inputRef.current, { mode: 'dp-below', min, max, inRange })
        .on('open', (_, dp) => { this.updateDPDate(); })
        // .on('statechange', (_, dp) => { console.log('ch:', dp.state.hilightedDate); })
        .on('select', (_, dp) => {
          let st = dp.state.selectedDate;
          // cehck null empty.
          // to server format
          let v = null;
          if (st) {
            const offset = st.getTimezoneOffset();
            st.setMinutes(st.getMinutes() - offset);
            v = st.toISOString().replace('T', ' ').replace('Z', '');
            // console.log('v:', st.toISOString(), st.getTimezoneOffset() / 60, v);
          }
          if (onChange) {
            if (skipTime && v) {
              v = v.substr(0, 10) + ' 00:00:00.000';
            }
            onChange({ target: { value: st ? v : st, name } });
          }
        });
    }
    if (type === 'date-range') {
      DateRangePicker(inputRef.current, { mode: 'dp-below' })
        .on('select', () => {
          if (onChange) onChange({ target: this.input.current });
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.multiline !== prevProps.multiline && this.focused) {
      this.inputRef.current.focus();
      setCaretPosition(this.inputRef.current, this.props.value.length);
    }
  }

  updateDPDate = () => {
    const dp = this.dp;
    const value = this.props.value;
    // console.log('valid:', this.invalidValue, value);
    if (!this.invalidValue) {
      // const v = this.invalidValue ? this.lastValidValue : value;
      const v = value;
      const hiDate = value ? new Date(v) : new Date();
      dp.setState({ hilightedDate: hiDate });
      // console.log('upd:', value, hiDate);
    }
  };

  onChange = (ev) => {
    let { type, onChange, date, format } = this.props;
    let invalidValue = ev.target.value;
    let isValid = true;
    const lastValidValue = this.props.value;

    // console.log('onchange:', ev);
    if (type === 'date') {
      // (changing date manually)
      // check value is valid
      // if value is null or empty string it is valid
      if (invalidValue) {
        let parsed = parseDateValue(invalidValue, isDDMMFormat() ? '%d/%m/%Y' : '%m/%d/%Y');
        isValid = parsed != null;
      } else {
        isValid = true;
      }
      // console.log('valid:', isValid);
    }

    if (isValid) {
      this.invalidValue = null;
      if (type === 'date') {
        // !! when changing, check that it works in date+time fields

        const values = ev.target.value?.split('/');
        let newValue = '';
        let v = '';
        if (values?.length === 3) {
          // need to handle DD/MM/YYYY somehow
          // what if we have other formats becides MM/DD/YYYY and DD/MM/YYYY ?
          if (isDDMMFormat()) newValue = values[2] + '-' + values[1] + '-' + values[0];
          else newValue = values[2] + '-' + values[0] + '-' + values[1];
          ev.target.value = newValue;

          // console.log('dp:', this.dp);
          // console.log('ddmm:', isDDMMFormat(), ev?.target?.value);
          v = ev.target.value + ' 00:00:00.000';
        }

        // console.log('v:', v);
        ev.target.value = v;
      }
      onChange(ev);
    } else {
      this.invalidValue = invalidValue;
      this.lastValidValue = lastValidValue;
    }

    if (type === 'date') {
      // update datepicker
      setTimeout(() => { this.updateDPDate(); }, 0);
    }
  };

  onBlur = ev => {
    const { onBlur, type } = this.props;
    this.focused = false;
    const v = this.props.value;
    if (type !== 'date' && v > '' && v !== v?.trim()) this.props.onChange({ target: { value: v?.trim(), name: this.props.name } });

    if (this.invalidValue) {
      this.invalidValue = null;
    }
    if (onBlur) onBlur.call(this, ev);
    if (type === 'date' && this.props.value) {
      this.props.onChange({ target: { value: this.props.value, name: this.props.name } });
    }
  };

  handleFocus = (event) => {
    this.props.onFocus?.(event);
    this.focused = true;
  };

  render() {
    const {
      name,
      multiline,
      value,
      autoComplete,
      className,
      inRange,
      onInputClick,
      inputRef,
      onChange,
      nostyle,
      format,
      empty,
      autocomplete,
      withTime,
      lookupFreeAdd,
      overwriteRowCount,
      skipDefaultClass,
      placeHolder,
      labelText,
      skipTime,
      acFree,
      ...rest
    } = this.props;
    const clInput = classFormControl({ ...this.props, skipDefaultClass, nostyle });

    const inputProps = {
      ...rest,
      name,
      id: (rest.id || name)?.replace(/:/g, '__'),
      value: this.invalidValue != null ? this.invalidValue : formatValue(value, rest.type, format) || value,
      className: classnames(className, clInput),
      ref: inputRef || this.inputRef,
      onClick: onInputClick,
      onChange: this.onChange,
      placeholder: placeHolder,
    };

    // if type of a field date, we apply datepicker
    if (inputProps.type === 'date') {
      // console.log('v:', this.invalidValue, value, formatValue(value, rest.type, format));
      inputProps.type = 'text';
      inputProps.date = '1';
      // we handle linkge in componentDidMount
    }

    // if null, we want to make sure to put empty string,
    // to prevent error Control <=> Uncontrolled
    if (inputProps.value === null) inputProps.value = '';

    /*
    // replaced with updateDPDate()
    if (rest.type === 'date' && isDDMMFormat()) {
      // how to do DD/MM/YYY with datepicker?
      // !! temporary
      // console.log('click:', name, value, inputProps.value);
      let datePickerID = inputProps.id + '_hidden';
      const onClick = () => {
        // console.log('click:', value, inputProps.value);
        const elem = document.getElementById(datePickerID);
        const elem2 = document.getElementById(inputProps.id);
        if (elem) {
          elem.focus();
          datePickerID = inputProps.id + '_disabled';
          if (elem2) elem2.focus();
        } else {
          datePickerID = inputProps.id + '_hidden';
        }
      };
      console.log('value:', name, value, inputProps.value);
      return (
        <>
          <input {...inputProps} ref={null} onBlur={this.onBlur} autoComplete="off" onClick={onClick} />
          <input {...inputProps} value={value} onBlur={this.onBlur} id={datePickerID} className={inputProps.className + ' input-date-hidden'} />
        </>
      );
    }
    */

    return (multiline ? <textarea {...inputProps} /> : <input {...inputProps} onBlur={this.onBlur} onFocus={this.handleFocus} autoComplete={autoComplete || 'off'} />);
  }
});

MSInputSimple.displayName = 'MSInputSimple';
